import { createContext, useContext } from 'react';
export var ApolloClientsContext = createContext(null);
var ApolloClientsManager = /** @class */ (function () {
    function ApolloClientsManager(clients) {
        this.clients = clients;
    }
    ApolloClientsManager.prototype.getClient = function (key) {
        if (key === void 0) { key = 'default'; }
        return this.clients[key];
    };
    ApolloClientsManager.prototype.extract = function () {
        var result = {};
        for (var _i = 0, _a = Object.entries(this.clients); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            result[key] = value.extract();
        }
        return result;
    };
    return ApolloClientsManager;
}());
export { ApolloClientsManager };
export function useContextApolloClient(clientOrName) {
    var apolloClientsContext = useContext(ApolloClientsContext);
    if (!clientOrName) {
        return apolloClientsContext.getClient();
    }
    else if (typeof clientOrName === 'string') {
        return apolloClientsContext.getClient(clientOrName);
    }
    else {
        return clientOrName;
    }
}
//# sourceMappingURL=ApolloClientsContext.js.map